import { styled } from "@mui/material/styles";

import { VIRTUAL_LIST_CLASSES } from "./constants";

export const VirtualListContainer = styled("div")(() => {
  return {
    height: "100%",
    width: "100%",
    overflow: "auto",
    [`& .${VIRTUAL_LIST_CLASSES.virtaulListItem}`]: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
    },
    [`& .${VIRTUAL_LIST_CLASSES.virtualListContainer}`]: {
      width: "100%",
      position: "relative",
      margin: 0,
      padding: 0,
    },
  };
});
